import React from 'react';
import {AuthedLayout} from 'components/Layout';

const SetupLazy = React.lazy(() => import(/* webpackChunkName: "Setup" */ './Setup'));

export const Setup = props => <AuthedLayout component={SetupLazy} {...props} />;
